module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }